import React from 'react';

// 6 px brand-gradient strip rendered above every left panel.
// lime → mint, the brand accent pair applied as a thin signature stripe.
export const ChromeBar: React.FC = () => (
  <div
    className="h-1.5 flex-shrink-0"
    style={{
      background: 'linear-gradient(90deg, #c1f04f 0%, #46ce85 100%)',
    }}
    aria-hidden="true"
  />
);
